import React from 'react';
import { ContentBannerProps } from '@jbhi-fi/components/src/ContentBanner/ContentBanner';
import { ContentfulImage } from '@jbhi-fi/components/src/ContentfulImage/ContentfulImage';
import { ContentfulContentBanner } from '@jbhi-fi/apis/src/contentful/types';
import { AssetTransformer } from '@jbhi-fi/components/src/Contentful/transformers/AssetTransformer';
import { AlignedButton, AlignedButtonProps } from '@jbhi-fi/components/src/AlignedButton/AlignedButton';
import { ButtonTransformer } from '@jbhi-fi/components/src/Contentful/transformers/ButtonTransformer';
import { ThemeTransformer } from './ThemeTransformer';
import { TermsAndConditionsTransformer } from './TermsAndConditionsTransformer';

export type ContentBannerPropsOptions = {
  onClick?: AlignedButtonProps['onClick'];
};

export abstract class ContentBannerTransformer {
  static toContentBannerProps = (
    { fields }: ContentfulContentBanner,
    options: ContentBannerPropsOptions = {}
  ): ContentBannerProps => {
    const coverImage = fields?.heroImage?.fields ? AssetTransformer.toContentfulImageProps(fields.heroImage) : null;
    const ctaButton = fields?.button?.fields ? ButtonTransformer.toAlignedButtonProps(fields.button) : null;
    const categoryTheme = fields?.categoryColour?.fields
      ? ThemeTransformer.toLegacyContentThemeProps(fields.categoryColour)
      : null;

    return {
      coverImage: coverImage?.src ? <ContentfulImage {...coverImage} sizes="(max-width: 768px) 100vw, 50vw" /> : null,
      heading: fields?.heading ?? '',
      content: fields?.subText ?? '',
      ctaButton: ctaButton ? (
        <AlignedButton {...ctaButton} onClick={options?.onClick ?? ctaButton?.onClick} />
      ) : undefined,
      topBorderColor: categoryTheme?.backgroundColor,
      termsAndConditions: TermsAndConditionsTransformer.toTermsAndConditions(fields?.termsConditions),
    };
  };
}
